( function( $ ) {
	'use strict';

	var finderToggle = $( '.finder-search__toggle' );

	finderToggle.on( 'click', function() {
		$( this ).toggleClass( 'finder-search--active' );
		$( this ).prev().toggleClass( 'finder-search--active' );
	} );

} )( jQuery );
